/* eslint-disable */

/** Data associated with a customer's Identity Hub state */
export interface IdentityHubState {
  entrypoint_status?: IdentityHubStateEntrypointStatus;
  should_show_badge?: boolean;
  version?: number;
}

export enum IdentityHubStateEntrypointStatus {
  VERIFY = "VERIFY",
  CONTINUE = "CONTINUE",
  PENDING = "PENDING",
  NOT_VERIFIED = "NOT_VERIFIED",
  VERIFIED = "VERIFIED",
}
